<template>
	<div class="flex-wrapper">
		<TypographyTitle :level="2" class="flex-grow">
			{{ $t('rovers.header') }}
		</TypographyTitle>
		<Button v-if="userStore.allowAddUpdateRover" type="primary" @click="onAddRover">
			<PlusCircleOutlined /> {{ $t('rovers.addRoverButtonLabel') }}
		</Button>
	</div>
	<Table
		:columns="columns"
		:data-source="roversStore.rovers"
		:pagination="false"
		:bordered="true"
		:loading="roversStore.isLoading"
	>
		<template #bodyCell="{ column, record }">
			<template v-if="column.key === 'label'">
				<router-link v-if="userStore.allowAddUpdateRover" :to="{ name: 'rover-page', params: { roverId: record.id } }">
					{{ record.label }}
				</router-link>
				<span v-else>{{ record.label }}</span>
			</template>
			<template v-else-if="column.key === 'display_status'">
				<RoverStatusBadge :status="record['display_status']" />
			</template>
			<template v-else-if="column.key === 'geo_fencing'">
				<GeoFencingDisplay :geoFencing="record['geo_fencing']" />
			</template>
			<template v-else-if="column.key === 'actions'">
				<RoverActionBar :rover="record" />
			</template>
			<template v-else-if="column.key === 'tariff'">
				<TariffDisplay :tariff="record.tariff" :class="{ pointer: userStore.allowChangeTariff }" @click="onTariffClick(record.id)" />
			</template>
		</template>
	</Table>
</template>

<script>
import { onMounted } from 'vue';
import { TypographyTitle, Button, Table } from 'ant-design-vue';
import { PlusCircleOutlined } from '@ant-design/icons-vue';

import RoverStatusBadge from '@/components/rovers/RoverStatusBadge';
import GeoFencingDisplay from '@/components/rovers/GeoFencingDisplay';
import RoverActionBar from '@/components/rovers/RoverActionBar';
import TariffDisplay from '@/components/rovers/TariffDisplay';

import { useRouter } from 'vue-router';
import { useInterval } from '@/utils/useInterval';

import { useRoversStore } from '@/stores/rovers';
import { useUserStore } from '@/stores/user';

import TranslationUtils from '@/i18n/TranslationUtils';

export default {
	components: {
		TypographyTitle, Button, Table,
		RoverStatusBadge, GeoFencingDisplay, RoverActionBar, TariffDisplay,
		PlusCircleOutlined,
	},
	setup() {
		const userStore = useUserStore();
		const columns = TranslationUtils.addTranslatedField(
			userStore.roversTableColumns,
			'key', 'title',
			'rovers.tableColumns',
		);
		const router = useRouter();
		const onAddRover = () => router.push({ name: 'add-rover' });

		const roversStore = useRoversStore();
		onMounted(roversStore.updateRoversList);
		useInterval(roversStore.updateRoversList, 10000, true);

		const onTariffClick = roverId => {
			if (!userStore.allowChangeTariff) {
				return;
			}
			router.push({
				name: 'rover-change-tariff',
				params: { roverId },
			});
		};
		return {
			columns,
			userStore,
			roversStore,
			onAddRover,
			onTariffClick,
		};
	},
}
</script>
